var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',{staticClass:"row"},[_vm._l((_vm.items),function(item,index){return [_c('PanelCol',_vm._b({key:_vm._uid + index},'PanelCol',item,false),[(item.slotName)?_vm._t(item.slotName):_vm._e()],2)]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }